import simpleheat from 'simpleheat';
import HeatmapLayer from 'react-leaflet-heatmap-layer';

const draw = simpleheat.prototype.draw;

if (!simpleheat.prototype._ioaZeroSizeGuard) {
  simpleheat.prototype.draw = function drawWithZeroSizeGuard(minOpacity) {
    if (this._width < 1 || this._height < 1) {
      return this;
    }

    return draw.call(this, minOpacity);
  };

  simpleheat.prototype._ioaZeroSizeGuard = true;
}

export default HeatmapLayer;
